import {
    GET_SHOP_THE_LOOK_PRODUCTS_SUCCESS,
    GET_SHOP_THE_LOOK_PRODUCTS_ERROR,
    FOUND_RELATED_PRODUCTS
} from '../actions/shopTheLookActions';

import { setStrategyName } from "../utils/shopTheLookUtils";

export function shopTheLookSubReducer(state = {}, action = {}) {
    switch (action.type) {
        case GET_SHOP_THE_LOOK_PRODUCTS_SUCCESS:
            if (action.payload && action.payload.length > 0) {
                return Object.assign({}, state, {
                    shopTheLook: Object.assign({}, state.shopTheLook, {
                        products: setStrategyName(action.payload)
                    }),
                    productMeta: Object.assign({}, state.productMeta, {
                        isShopTheLook: true
                    })
                });
            }

            return Object.assign({}, state, {
                shopTheLook: undefined,
                productMeta: Object.assign({}, state.productMeta, {
                    isShopTheLook: false
                })
            });
        case GET_SHOP_THE_LOOK_PRODUCTS_ERROR:
            return Object.assign({}, state, {
                shopTheLook: undefined,
                productMeta: Object.assign({}, state.productMeta, {
                    isShopTheLook: false
                })
            });
        case FOUND_RELATED_PRODUCTS:
            return Object.assign({}, state, {
                shopTheLook: Object.assign({}, state.shopTheLook, {
                    tileInfo: action.payload
                })
            });
        default:
            return state;
    }
}
